// TODO: Remove this component as soon as possible. Use the prop `plain` in `Icon` instead.

import styled, { css, FlattenSimpleInterpolation } from "styled-components";
import { FC } from "react";

import { BaseComponentProps } from "../types";
import { BaseIcon } from "./BaseIcon";
import { SizedIcon } from "./SizedIcon";
import { IconName, IconSize, IconVariant } from "./types";

type StyledPlainIconProps = {
  $variant?: IconVariant;
};

export const StyledPlainIcon = styled(SizedIcon)<StyledPlainIconProps>`
  ${({ $variant }): FlattenSimpleInterpolation => {
    switch ($variant) {
      case "DISABLED":
        return css`
          svg {
            --main-color: var(--color-primary-200);
          }
        `;

      case "ACTIVE":
        return css`
          svg {
            --main-color: var(--color-secondary-800);
          }
        `;

      case "INACTIVE":
        return css`
          svg {
            --main-color: var(--color-primary-400);
          }
        `;

      case "DEFAULT":
      default:
        return css`
          svg {
            --main-color: var(--color-primary-800);
          }
        `;
    }
  }}
`;

type PlainIconProps = BaseComponentProps<
  "svg",
  {
    /** The icon that will be rendered. */
    iconName: IconName;

    /** The size of icon that will be rendered. */
    iconSize?: IconSize;

    /** The type of icon that will be rendered. */
    variant?: IconVariant;
  }
>;

export const PlainIcon: FC<PlainIconProps> = ({
  iconSize = "regular",
  variant = "DEFAULT",
  ...props
}) => (
  <StyledPlainIcon $iconSize={iconSize} $variant={variant}>
    <BaseIcon disabled={variant === "DISABLED"} {...props} />
  </StyledPlainIcon>
);

export const SmallPlainIcon: FC<PlainIconProps> = ({
  iconSize = "small",
  variant = "DEFAULT",
  ...props
}) => {
  return (
    <StyledPlainIcon $iconSize={iconSize} $variant={variant}>
      <BaseIcon disabled={variant === "DISABLED"} {...props} />
    </StyledPlainIcon>
  );
};
